import { CallToActionHero } from 'components/hero/CallToActionHero';
import { FunctionComponent } from 'react';
import { SearchContext } from 'components/search/SearchContext';
import { SearchNavigation } from 'components/search/SearchNavigation';
import { SearchRedirect } from 'components/search/SearchRedirect';
import { WidgetConsumerPageContent } from 'components/www/WidgetConsumerPageContent';
import { stringify } from '@tock/query-string';
import { useCurrentMetroArea } from 'hooks/useCurrentMetroArea';
import { useHistory, useLocation } from 'react-router-dom';

export const ToGoSearchLanding: FunctionComponent = () => {
  const currentMetroArea = useCurrentMetroArea();
  const history = useHistory();
  const location = useLocation();
  const handleClickCallToActionHero = () => {
    history.push({
      pathname: '/togo/search',
      search: stringify({
        city: currentMetroArea?.name,
      }),
    });
  };

  const title = 'Food, cocktails, & wine—to go.';
  const subTitle =
    'Find something delicious, order your favorite takeout, and support local restaurants.';

  return (
    <>
      <SearchNavigation />
      <SearchRedirect type="togo" />
      <SearchContext
        locale={currentMetroArea?.locale ?? 'en-us'}
        currencyCode={currentMetroArea?.currencyCode ?? 'USD'}
        type="togo"
      >
        <div className="PageContent PageContent--page-search">
          <CallToActionHero
            buttonText="Explore the map"
            onClick={handleClickCallToActionHero}
            subtitle={subTitle}
            title={title}
          />
          <div className="DiscoverPage-results" data-testid="discoverpage-results">
            <WidgetConsumerPageContent pathname={location.pathname} standAlone={false} />
          </div>
        </div>
      </SearchContext>
    </>
  );
};
